import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AccountService } from 'src/app/services/user/account.service';
import { MessageDataService } from 'src/app/services/message/message-data.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss'],
})
export class GenericModalComponent implements OnInit, OnDestroy {
  @Input() icon: string;
  @Input() img: string;
  @Input() heading: string;
  @Input() message: string;
  @Input() message2: string;
  @Input() isPrompt: number;
  @Input() isCancelBooking: number;
  @Input() returnPositve: any;
  @Input() returnNegative: any;
  @Input() yesBtnText: string;
  @Input() noBtnText: string;
  @Input() isUpgrade: boolean;
  @Input() okayBtnText: string;
  @Input() returnOkay: any;
  @Input() cancelBookingV2: string;
  @Input() notMeText: string;
  @Input() notMeActionText: string;
  @Input() returnNotMe: any;

  private messageSubscription?: Subscription;

  constructor(
    private modalController: ModalController,
    private messageDataService: MessageDataService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    if (!this.isUpgrade) {
      this.isUpgrade = false;
    }
    this.messageSubscription = this.messageDataService.getMessage().subscribe(
      (value) => {
        if (value) {
          this.message = value;
          this.messageDataService.updateMessage('');
        }
      },
      (error) => {
        this.analyticsService.trackError(error);
      }
    );
  }

  ngOnDestroy() {
    this.messageSubscription?.unsubscribe();
  }

  handlePostiveResponse() {
    this.modalController.dismiss(this.returnPositve || {});
  }

  handleNegativeResponse() {
    this.modalController.dismiss(this.returnNegative || {});
  }

  handleOkayResponse() {
    this.modalController.dismiss(this.returnOkay || {});
  }

  handleNotMeResponse() {
    this.modalController.dismiss(this.returnNotMe || {});
  }
}
